import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from 'app/services/api/translation/translation.service';

@Pipe({ name: 'translate' })
export class TranslationPipe implements PipeTransform {
    constructor(private translationService: TranslationService) {}
    transform(key: string, params: any) {
        return this.translationService.translate(key, params);
    }
}

@Pipe({ name: 'translatePlural' })
export class TranslationPluralPipe implements PipeTransform {
    constructor(private translationService: TranslationService) {}
    transform(key: string, params: any) {
        return this.translationService.translatePlural(key, params);
    }
}
